import { cloneDeep } from 'lodash';

import {
  saveCookieConsent,
  getCookieValue,
  saveExtraAliasInfo,
} from '../../utils/cookie';
import { getOrgByAlias } from '../../actions/loginAuth';
import { withClientToken } from '../../actions/helpers/tokenHelpers';
import { ACTIONS as layoutActions } from '../layout';

const INIT = 'orgSelection/INIT';
const SET_COOKIE_MSG = 'orgSelection/SET_COOKIE_MSG';
const SET_FIELDS = 'orgSelection/SET_FIELDS';
const SET_ERROR = 'orgSelection/SET_ERROR';

const defaultState = {
  fields: {
    orgId: '',
  },
  cookieMsg: false,
  orgSelectionErrMsg: '',
  passwordRegex: '',
  showRegisterForm: true,
  validationTxt: {},
};

const setFields = fields => ({ type: SET_FIELDS, fields });

const setCookieMsg = bool => ({ type: SET_COOKIE_MSG, bool });

// const setError = err => ({ type: SET_ERROR, err });

const setFieldsVal = (field, val) => (dispatch, getState) => {
  const { fields } = getState().routes.orgSelection;

  const clonedFields = cloneDeep(fields);

  clonedFields[field] = val;

  dispatch(setFields(clonedFields));
};

const handleSignIn = () => async (dispatch, getState) => {
  saveCookieConsent(true);
  const { fields } = getState().routes.orgSelection;

  const { orgId } = fields;

  if (!orgId) {
    dispatch(layoutActions.setAlert("Company ID can't be empty", 'danger'));
    // dispatch(setError("Company ID can't be empty"));
    return;
  }

  try {
    const response = await withClientToken({
      action: getOrgByAlias,
      args: [orgId],
    });

    const { error, errorCode, ...apiData } = response;

    const {
      password_regex: passwordRegex,
      show_registration_form: showRegForm,
      // validationTxt,
      id: responseOrgId,
    } = apiData;

    const validationTxt = {
      '1': 'Password must be atleast 12 characters long',
      '2': 'Password must contain atleast 1 uppercase letter',
      '3': 'Password must contain atleast one lowercase letter',
      '4': 'Password must contain atleast one number',
      '5': 'Password must contain atleast one special character',
    };

    const extraAliasInfo = {
      passwordRegex,
      showRegForm,
      validationTxt,
      responseOrgId,
    };

    saveExtraAliasInfo(extraAliasInfo);

    // const responseOrgId = response.id;
    const { protocol, host } = window.location;

    const newLocation = `${protocol}//${host}/api/login-redirect?orgId=${responseOrgId}`;
    
    if (!error) {
      window.location.replace(newLocation);
    }

    if (errorCode === 400) {
      dispatch(
        layoutActions.setAlert('Please enter a valid company ID', 'danger'),
      );
      // dispatch(setError('Please enter a valid company ID'));
    }
    if (errorCode === 500) {
      dispatch(
        layoutActions.setAlert(
          'Some error occured. Try again after some time',
          'danger',
        ),
      );
      // dispatch(setError('Some error occured. Try again after some time'));
    }
  } catch (err) {
    console.error(err);
  }
};

const promptCookie = () => dispatch => {
  const cookieConsent = getCookieValue('cookie_consent');

  if (cookieConsent) {
    dispatch(handleSignIn());
  } else {
    dispatch(setCookieMsg(true));
  }
};

const declineCookie = () => dispatch => {
  dispatch(setCookieMsg(false));
};

const enterPressHandler = () => dispatch => {
  dispatch(handleSignIn());
};

export const ACTIONS = {
  init: () => ({ type: INIT }),
  setFieldsVal,
  handleSignIn,
  promptCookie,
  declineCookie,
  enterPressHandler,
};

function orgSelection(state = defaultState, action) {
  switch (action.type) {
    case INIT:
      return Object.assign({}, state);
    case SET_FIELDS:
      return Object.assign({}, state, {
        fields: action.fields,
      });
    case SET_COOKIE_MSG:
      return Object.assign({}, state, {
        cookieMsg: action.bool,
      });
    case SET_ERROR:
      return Object.assign({}, state, {
        orgSelectionErrMsg: action.err,
      });
    default:
      return Object.assign({}, state);
  }
}

export default orgSelection;



// WEBPACK FOOTER //
// ./src/reducers/routeReducers/orgSelection.js